<template>
    <section id="faqs-wrapper" class="faqs-wrapper">
        <div id="faqs" class="faqs">
            <div class="container">
                <h3 class="title">{{ $t( 'homepage.faqsTitle' ) }}</h3>
                <div class="item" v-for="(item, index) in faqs" :key="index">
                    <a href="javascript:void(0);" :id="index" class="hash-target"></a>
                    <div class='quesBox'
                        @click="updateExpand(index)"
                    >
                        <h5 class="ques">{{ item.ques }}</h5>
                        <button
                            class="button_clear expand-btn"

                        >
                            <i
                                class="icon icon-co_add"
                                :class="{'expand': item.expand}"
                            />
                        </button>
                    </div>
                    <template v-if="item.expand">
                        <p class="des"
                            v-for="(n, i) in item.des"
                            :key="i"
                            v-html="$t(`homepage.faqsQues.${index}.des.${i}`, {
                                link: links[index]
                            } )"></p>
                    </template>
                </div>
                <a v-if="!FEATURE('homepage.explore_more')"
                    :href="config.support_cloud_url"
                    target="_blank"
                    class="ui-link cloud-support">
                    <span class="text">{{ $t('homepage.cloud_support') }}</span>
                    <span class="ui-icon icon-icon_arrow-right"></span>
                </a>
            </div>
        </div>
        <div class="tip" id="tip" v-if="!isApp">
            {{ $t('homepage.ai_tip') }}
            <reo-link
                :href="config.ai_support"
                :text="$t('totp.learnMore')"
                :size="14"
            />
        </div>
    </section>
</template>

<script lang="ts">
import Vue from 'vue';
import { config } from 'CONFIG';
import * as _ from '@reolink-web/utils';
import ReoLink from '@/basic/Link.vue';
import { isApp } from '@/utils/business';

type faqsQues = Record<string, {
    ques: string;
    des: string[];
    expand: boolean;
}>;

export default Vue.extend({
    components: {
        ReoLink,
    },
    data() {

        const faqs = _.Object.deepClone( this.$t( 'homepage.faqsQues' )) as unknown as faqsQues;
        for ( const key in faqs ) {

            this.$set( faqs[key], 'expand', false );

        }

        return {
            config,
            faqs,
        };

    },
    computed: {
        links(): Record<string, string> {

            return {
                account: config.signipRedirect,
                advancedDataProtection: config.e2ee_support,
                cloudAIAvailability: config.ai_support,
            };

        },
        isApp(): boolean {

            return isApp;

        }
    },
    methods: {
        updateExpand( key: string ) {

            this.faqs[key].expand = !this.faqs[key].expand;

        }
    }
});

</script>

<style lang="less" scoped>
.faqs-wrapper{
    background-color: @bg_02;
    .faqs {
        max-width: 800px;
        padding-top: 80px;
        margin: 0 auto;
        .mobile({
            .mobileMaxWidth();
            padding: 40px 20px;
        });

        .container{
            .title {
                font-size: 42px;
                font-weight: 600;
                line-height: 54px;
                margin-bottom: 50px;
                .mobile({
                    font-size: 24px;
                    line-height: 36px;
                    margin-bottom: 24px;
                    text-align: center
                });
            }
            .item {
                text-align: left;
                padding-bottom: 16px;
                margin-bottom: 16px;
                border-bottom: 1px solid @line;
                &:first-of-type {
                    margin-top: 40px;
                }
                .quesBox{
                    display: flex;
                    justify-content: space-between;
                    cursor: pointer;
                    align-items: flex-start;
                    .expand-btn{
                        font-size: 24px;
                        .icon{
                            transition: transform 0.5s ease;
                            color: @font_primary;
                            &.expand{
                                transform: rotate(45deg);
                            }
                        }
                    }
                }
                .ques {
                    font-size: 18px;
                    font-weight: 400;
                    line-height: 27px;
                }
                .des {
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 27px;
                    margin-top: 12px;
                    a{
                        color: @theme;
                        &:hover{
                            text-decoration: underline;
                        }
                    }
                }

            }
            .cloud-support{
                display: inline-block;
                margin-bottom: 36px;
                .mobile({
                    margin-bottom: 0;
                });
            }
        }
    }
    .tip{
        background-color: @bg_02;
        padding: 24px 0;
        display: flex;
        justify-content: center;
        font-size: 14px;
        line-height: 21px;
        font-weight: 500;
        .mobile({
            display: block;
            .mobileMaxWidth();
            padding-bottom: 24px;
        });
        /deep/ a {
            .text{
                font-weight: 500;
                line-height: 21px;
                margin-left: 4px;
            }
        }
    }
}
</style>
